<div #scannerHost class="strich-barcode-reader"></div>
